// Instância única do cliente da API e do cache de consultas.

import { createApi, type Session } from "@acervo/api-client";
import { QueryClient } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

type Listener = () => void;
const listeners = new Set<Listener>();
let current: Session | null = null;

export const api = createApi({
  // Vazio em desenvolvimento: as chamadas passam pelo proxy do Vite.
  baseUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? "",
  onSession: (s) => {
    const loggedOut = current !== null && s === null;
    current = s;
    if (loggedOut) queryClient.clear(); // nada da conta anterior fica no cache
    listeners.forEach((l) => l());
  },
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => count < 2 && !(err instanceof Error && "status" in err && Number(err.status) < 500),
    },
  },
});

/** Sessão atual; re-renderiza quando a pessoa entra, sai ou a sessão é renovada. */
export function useSession(): Session | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}

export function onSessionChange(l: Listener): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export const isAdmin = (s: Session | null) => s?.user.role === "owner" || s?.user.role === "admin";
